// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'
import type { Rules } from 'frame/core/formValidate'
import * as React from 'react'
import computeData from '../hoc/computeData'
import { validate } from 'frame/core/formValidate'
import { isInIOS } from 'frame/core/browserEnv'

type Props = BasicProps & {
  style: { [string]: string },
  field: string,
  rules: Rules,
  maxLength?: number,
  placeholder: string,
  formValues: { [string]: string },
  customProps: any,
  setFormValues: ({ [key: string]: any }) => void,
  blurReset: boolean,
  events?: Object
};

@computeData()
export default class InputTextarea extends React.PureComponent<
  Props,
  { isFocus: boolean }
> {
  state = {
    isFocus: false
  };
  textArea: ?HTMLTextAreaElement;
  changeTimer: any;

  static schema: PropsSchema = [
    {
      key: 'field',
      title: '字段',
      type: 'text'
    },
    {
      key: 'placeholder',
      title: '占位内容',
      type: 'text'
    },
    {
      key: 'maxLength',
      title: '最大长度',
      type: 'number'
    },
    {
      title: '校验规则列表',
      type: 'array',
      key: 'rules',
      item: [
        {
          type: 'select',
          key: 'type',
          title: '规则：',
          options: [
            ['required', '必填'],
            ['mobile', '手机号'],
            ['idCard', '身份证'],
            ['bankCard', '银行卡'],
            ['zh_cn', '汉字'],
            ['number', '数字'],
            ['en_us', '字母'],
            ['regex', '自定义正则表达式']
          ],
          defaultValue: 'required'
        },
        {
          type: 'text',
          key: 'regex',
          title: '正则',
          visible: props => props.type === 'regex'
        },
        {
          type: 'text',
          key: 'message',
          title: '提示消息'
        }
      ]
    },
    'separator',
    {
      type: 'style'
    },
    'separator',
    {
      type: 'event',
      title: '获得焦点',
      event: 'onFocus'
    },
    {
      type: 'event',
      title: '失去焦点',
      event: 'onBlur'
    },
    {
      type: 'event',
      title: '改变',
      event: 'onChange'
    },
    {
      type: 'event',
      title: '延迟改变',
      event: 'onDelayChange'
    },
    {
      type: 'event',
      title: '校验成功',
      event: 'resolve'
    },
    {
      type: 'event',
      title: '校验失败',
      event: 'reject'
    },
    {
      type: 'boolean',
      key: 'blurReset',
      title: '失去焦点复位(仅ios)'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '数据校验',
      name: 'validate'
    },
    {
      title: '获得焦点',
      name: 'focus'
    }
  ];

  componentDidUpdate (preProps: Props) {
    let { callActions } = this.props
    if (this.getFieldValue(preProps) !== this.getFieldValue()) {
      if (this.isExistDelayChange()) {
        if (this.changeTimer) {
          clearTimeout(this.changeTimer)
        }
        let value = this.getFieldValue()
        this.changeTimer = setTimeout(() => {
          callActions('onDelayChange', value)
        }, 200)
      }
      //
      callActions('onChange', this.getFieldValue())
    }
  }

  isExistDelayChange () {
    const { events = {} } = this.props
    const { onDelayChange = {} } = events
    const { targets = [] } = onDelayChange
    return targets.length > 0
  }

  getFieldValue = (props?: Props): string => {
    const { field, formValues } = props || this.props
    return formValues[field] == null ? '' : formValues[field]
  };

  actionValidate = () => {
    const { callActions, rules } = this.props
    const fieldValue = this.getFieldValue()
    if (rules && rules.length > 0) {
      const error = validate(fieldValue, rules)
      if (!error.success) {
        callActions('reject', error)
      } else {
        callActions('resolve')
      }
    } else {
      callActions('resolve')
    }
  };

  actionFocus = () => {
    this.textArea && this.textArea.focus()
  };

  onChange = (event: SyntheticEvent<HTMLInputElement>) => {
    let { field, setFormValues } = this.props
    const value: string = event.currentTarget.value
    setFormValues({ [field]: value })
  };

  handelBlur = (event: SyntheticEvent<HTMLInputElement>) => {
    const { callActions, blurReset } = this.props
    if (blurReset && isInIOS() && document.body) {
      setTimeout(() => {
        document.body && (document.body.scrollTop += 1)
        window.scroll(0, 0)
      }, 1)
    }
    this.setState({ isFocus: false })
    callActions('onBlur', this.getFieldValue())
  };
  handleFocus = () => {
    this.setState({ isFocus: true })
    this.props.callActions('onFocus', this.getFieldValue())
  };
  render () {
    if (!this.props.visible) {
      return null
    }
    const { id, style, maxLength, field, jsEnv, placeholder } = this.props
    return (
      <textarea
        name={field}
        maxLength={maxLength}
        placeholder={jsEnv.getString(placeholder)}
        onChange={this.onChange}
        onBlur={this.handelBlur}
        onFocus={this.handleFocus}
        value={this.getFieldValue()}
        style={style}
        id={id}
        ref={ref => (this.textArea = ref)}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/form/FormTextarea.js